import React from 'react';
import { observer } from 'mobx-react';

import Button from 'components/Button';

import { useViewerControl } from 'libs/rendering/gltf/hooks';

import { ButtonBar, ButtonWrapper } from './returnButton.styled';

const ReturnButton = observer(function _ReturnButton() {
  const viewerControl = useViewerControl();

  if (
    viewerControl.currentTabLabel === viewerControl.defaultTabLabel ||
    viewerControl.currentTab === undefined
  )
    return null;

  const { currentTab, closeTab } = viewerControl;
  return (
    <ButtonBar>
      <ButtonWrapper>
        <Button
          text='Back to Assembly'
          icon='arrow_left'
          size='small'
          outline
          onClick={() => closeTab(currentTab.id, currentTab.cameraIx)}
        />
      </ButtonWrapper>
    </ButtonBar>
  );
});

export default ReturnButton;
